// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wqcfV_RX4mEbf0pOoCKsX","icon":"_1cHOm6BR1JFD5ksCuJkFe_","rotated":"_3-WlyzeYN9ei6_933qIxyy"};